import { enableProdMode, VERSION } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LicenseManager } from "ag-grid-enterprise";

if (environment.production) {
  enableProdMode();
}
// เพิ่มตรงนี้เพื่อสร้าง version parameter ที่เปลี่ยนทุกครั้งที่ build
(window as any).appVersion = VERSION.full + '-' + new Date().getTime();

LicenseManager.setLicenseKey("your license key");

platformBrowserDynamic().bootstrapModule(AppModule, { preserveWhitespaces: true })
  .catch(err => console.error(err));
